/* Akamai Player 
    * Class that directly integrates the Akamai player
*/

import jQuery from 'jquery';
let $ = jQuery;
import VideoPlayer from './VideoPlayer.js';
import 'LIBS/video-amp/amp/amp.js';

export default class AkamaiPlayer extends VideoPlayer {
    constructor(config) {
        super(config);
        this.config = config;
        this.element = config.element;

        //configuration object for akamai player
        this.config.paths = {
            "player" : '/assets/js/libs/video-amp/amp/',
            "resources" : '/assets/js/libs/video-amp/resources/',
            "plugins" : '/assets/js/libs/video-amp/akamai/amp/'
        };

        this.config.resources = [
            { "src" : "#{paths.player}amp.css", "type" : "text/css" }
        ];

        this.config.fullscreen = {
            'native' : true,
            'enabled' : true
        };

        this.config.share = {
            'enabled' : false
        };

        this.config.hls = {
            'resources' : [
                { 'type' : 'text/javascript', 'src' : '#{paths.resources}js/hls.js' }
            ],
            'quality' : {
                'startLevel' : -1
            },
            'data' : {
                'enableWorker' : true,
                'enableSoftwareAES' : true
            }
        };

        this.videoPlayer = akamai.amp.AMP.create(this.config.element, this.config);
        this.videoPlayer.addEventListener('ready', event => this.assignEvents(event));

    }

    assignEvents(event) {
        super.assignEvents();
        if (this.config.category == null || this.config.category === ''
            && this.config.name == null
            || this.config.name === '') {
            this.config.category = 'CategoryNotSet';
            this.config.name = 'NameNotSet';
        }

        //play
        this.videoPlayer.addEventListener('play', function () {
            this.throwAnalyticEvent(this.config.category, this.config.name, this.config.label);
        }.bind(this), false);
    }

    play() {
        this.videoPlayer.play();
    }

    pause() {
        this.videoPlayer.pause();
    }

    stop(){
        try {
            this.videoPlayer.end();

        }
        catch (e) {
        }
    }

    getVolume() {
        return this.videoPlayer.getVolume();
    }

    setVolume(volume) {
        this.videoPlayer.setVolume(volume);
    }

    onTimeUpdate() {
        return Math.round(getCurrentTime());
    }

    getCurrentTime() {
        return this.videoPlayer.getCurrentTime();
    }

    setCurrentTime(time) {
        this.videoPlayer.setCurrentTime(time);
    }

}


// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/VideoPlayers/AkamaiPlayer.js